/** Default phone country codes from device timezone / locale. */
const TZ_TO_CODE = {
  "Africa/Lagos": "+234",
  "Africa/Accra": "+233",
  "Africa/Johannesburg": "+27",
  "Africa/Cairo": "+20",
  "Africa/Nairobi": "+254",
  "Europe/London": "+44",
  "America/New_York": "+1",
  "America/Los_Angeles": "+1",
};

export function detectDefaultCountryCode() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (TZ_TO_CODE[tz]) return TZ_TO_CODE[tz];
    const lang = (navigator.language || "").toUpperCase();
    if (lang.includes("NG")) return "+234";
    if (lang.includes("GB")) return "+44";
    if (lang.includes("ZA")) return "+27";
  } catch {
    /* ignore */
  }
  return "+234";
}

export const COUNTRY_CODES = [
  { code: "+234", label: "🇳🇬 Nigeria" },
  { code: "+233", label: "🇬🇭 Ghana" },
  { code: "+27", label: "🇿🇦 South Africa" },
  { code: "+44", label: "🇬🇧 UK" },
  { code: "+1", label: "🇺🇸 US" },
  { code: "+254", label: "🇰🇪 Kenya" },
];

export function formatPhoneWithCode(countryCode, localNumber) {
  const digits = String(localNumber || "").replace(/\D/g, "");
  const cc = countryCode || "+234";
  if (!digits) return "";
  return `${cc}${digits.startsWith("0") ? digits.slice(1) : digits}`;
}
